import { createSlice } from '@reduxjs/toolkit';

const INITIAL_QUERY = '';

const initialState = {
    query: INITIAL_QUERY,
    searchFiltered: false,
};

const chatSearch = createSlice({
    name: 'chatSearch',
    initialState,
    reducers: {
        setChatSearch(state, action) {
            state.query = action.payload;
        },
        clearChatSearch(state) {
            state.query = INITIAL_QUERY;
        },
        setChatSearchFiltered(state, action) {
            state.searchFiltered = action.payload;
        },
    },
});

export const { setChatSearch, clearChatSearch, setChatSearchFiltered } = chatSearch.actions;
export default chatSearch.reducer;
